const state =
    {
        isXl: false,
        isLg: false,
        isMobile: false
    };

const mutations =
    {
        setViewPortSize(state, windowWidth) {
            if (windowWidth >= 1200) {
                state.isXl = true;
                state.isLg = false;
                state.isMobile = false;
            } else if (windowWidth >= 992 && windowWidth < 1200) {
                state.isXl = false;
                state.isLg = true;
                state.isMobile = false;
            } else if (windowWidth < 768) {
                state.isXl = false;
                state.isLg = false;
                state.isMobile = true;
            } else if (windowWidth >= 768 && windowWidth < 991) {
                state.isXl = false;
                state.isLg = false;
                state.isMobile = true;
            }
        }
    };

export default {
    state,
    mutations
};
